export default {
  isochrones: {
    'isochrones': 'Isócronas',
    'isochronesReady': 'Isócronas listas',
    'calculatingIsochrones': 'Calculando isócronas ...',
    'itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions': 'No se puede calcular la(s) isócrona(s) con las opciones establecidas. Prueba a poner isócronas más pequeñas.',
    'couldResolveTheSelectedPlaceAsASuitableCenter': 'El punto seleccionado no pudo convertirse en un centro adecuado.',
    'apiError': {
      '2003': 'La superficie de un polígono a evitar no podrá superar los 20.0000 kilómetros cuadrados.',
      '3001': 'Uno o más parámetros tienen un valor o formato incorrecto.',
      '3004': 'La combinación seleccionada de perfil, intervalo y tiempo o distancia supera el máximo admitido. Por favor, ajuste los valores.',
      '3099': 'No ha sido posible construir un mapa isócrono para los puntos y perfiles seleccionados.'
    },
    'genericErrorMsg': 'No fue posible calcular las isocronas.',
    timeoutError: 'La solicitud tardó demasiado y se canceló. Pruebe con rangos o intervalos más pequeños.'
  }
}
